import { Router, NavigationEnd } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { isDarkChromePath } from 'src/app/shared/dark-chrome';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;

  public noLoaderRoutes = [
    '/dashboard1',
    '/masters/usermaster',
    '/masters/productmaster',
    '/masters/rolemaster',
    '/masters/productconfiguration',
    '/numberactive/productallocation',
    '/transactions/schemedemapping',
    '/transactions/hologramdamage',
    '/reports/verificationrpt',
    '/reports/mappingrpt',
    '/reports/ratingrpt',
    '/reports/feedbackrpt',
    '/reports/demappingrpt',
    '/reports/damagerpt',
    '/configuration',
  ];

  // #right-panel's dark backdrop is only correct behind the pages that have
  // a dark form: the new dashboard family, Configuration and the modernised
  // (.saml) master/transaction/report pages - see app/shared/dark-chrome.ts.
  // Everything else (old dashboard, not-yet-modernised pages, ...) is fixed
  // light-on-white regardless of the selected appearance.
  get isDarkChromeRoute(): boolean {
    return isDarkChromePath(this.router.url);
  }

  constructor(public router: Router) {

  }

  /** Class on <body> while a dark page is showing in Dark appearance. The
   *  template's style.css gives <body> a light grey, which otherwise shows
   *  through wherever #right-panel doesn't reach - e.g. the strip at the
   *  bottom of the dashboard while the (fixed, scroll-revealed) footer is
   *  hidden. See body.sa-dark-chrome in styles.css. */
  private static readonly BODY_DARK_CLASS = 'sa-dark-chrome';
  private static readonly THEME_EVENT = 'sa-theme-change';

  private readonly syncBodyChrome = (): void => {
    const dark =
      this.isDarkChromeRoute && !document.body.classList.contains('light-mode');
    document.body.classList.toggle(DefaultLayoutComponent.BODY_DARK_CLASS, dark);
  };

  ngOnInit() {
    // Angular's router leaves scroll position exactly where it was on every
    // navigation (scrollPositionRestoration defaults to 'disabled') - so
    // opening a report/detail page from a link halfway down a long page
    // (e.g. the dashboard's "View Report"/"View Details" buttons) renders it
    // already scrolled to that same spot instead of its own top. Reset on
    // every completed navigation - both the window (the normal case here)
    // and #right-panel itself, in case a page's content ever scrolls that
    // container directly instead of the window.
    this.syncBodyChrome();
    window.addEventListener(DefaultLayoutComponent.THEME_EVENT, this.syncBodyChrome);
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.syncBodyChrome();
        window.scrollTo(0, 0);
        const rightPanel = document.getElementById('right-panel');
        if (rightPanel) rightPanel.scrollTop = 0;
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener(DefaultLayoutComponent.THEME_EVENT, this.syncBodyChrome);
    document.body.classList.remove(DefaultLayoutComponent.BODY_DARK_CLASS);
  }

}
